import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import SourceCard from "../SourceCard";

export const CanvasSourcesPane = observer(({ store }) => {
  const containerRef = useRef(null);
  const sources = store?.dedupedSources || [];
  const highlightedSourceIds = store?.highlightedSourceIds || [];

  useEffect(() => {
    if (!highlightedSourceIds?.length || !containerRef.current) return;
    const card = containerRef.current.querySelector(`[data-source-id="${highlightedSourceIds[0]}"]`);
    card?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [highlightedSourceIds]);

  if (!sources.length) {
    return (
      <div className="canvas-sources-empty">
        <p>No sources yet.</p>
        <p>Links from the conversation will appear here.</p>
      </div>
    );
  }

  return (
    <div ref={containerRef} className="canvas-sources-list">
      {sources.map(source => (
        <SourceCard key={source.id} source={source} />
      ))}
    </div>
  );
});

export default CanvasSourcesPane;
